import { Injectable } from '@angular/core';
import { WindowRef } from '../window/window.component';

@Injectable()
export class MapsLoaderService {

    constructor(private windowRef: WindowRef) {
    }

    onLoad(): Promise<boolean> {
        const w = this.windowRef.nativeWindow;
        return new Promise((resolve, reject) => {
            if (w.PAY && w.PAY.mapsReady) {
                if (w.google && w.google.maps) {
                    resolve(true);
                } else {
                    console.warn('mapsReady but cant find google object on window.. rejecting..');
                    reject();
                }

            } else {
                w.initMaps = () => {
                    w.PAY.mapsReady = true;
                    resolve(true);
                };
            }
        })
    }
}
